import { dateTimeFormat } from './utils/helpers';

export const helpersPlugin: any = {
  install(app: any) {
    app.config.globalProperties.$helpers = {};
    app.config.globalProperties.$helpers.dateTimeFormat = dateTimeFormat;
  },
};
